import { fluxurilePentru } from "./fluxuri.js";
import { tr } from "./i18n.js";

/**
 * „Ești aici" — o linie deasupra ecranului, care arată din ce flux face parte
 * și ce vine înainte și după.
 *
 * Rostul nu e decorul: cineva care deschide Fișa de intervenție trebuie să
 * poată vedea, fără să întrebe pe nimeni, că înaintea ei a fost o vizită, iar
 * după ea vine devizul și predarea la facturare.
 *
 * Se randează doar dacă secțiunea chiar face parte dintr-un flux. Secțiunile de
 * administrare (utilizatori, drepturi, jurisdicție) nu fac parte din niciunul,
 * și e corect: nu sunt pași de proces, sunt reguli de casă.
 */
export default function BandaFlux({ sectiune, mergiLa }) {
  const gasite = fluxurilePentru(sectiune);
  if (!gasite.length) return null;

  return (
    <div className="banda-flux">
      {gasite.map(({ flux, pozitii }) => (
        <div key={flux.cod} className="banda-flux-linie">
          <span className="banda-flux-nume">{flux.titlu}</span>
          {flux.pasi.map((p, i) => (
            <span key={i} className="banda-flux-pas">
              {i > 0 && <span className="banda-flux-sageata">→</span>}
              {pozitii.includes(i) ? (
                <strong className="banda-flux-aici" title={p.face}>{p.titlu}</strong>
              ) : (
                <button className="banda-flux-buton" title={p.face}
                  onClick={() => mergiLa(p.sectiune)}>
                  {p.titlu}
                </button>
              )}
            </span>
          ))}
        </div>
      ))}
      <button className="banda-flux-tot" onClick={() => mergiLa("fluxuri")}>
        {tr("vezi tot fluxul")}
      </button>
    </div>
  );
}
